<template>
  <section class="three-box">
    <!-- <div class="glass-box"></div> -->
    <!-- 背景 -->
    <img src="../../assets/images/display_bg.png" class="bg">
    <!-- 下拉 -->
    <!-- <img src="../../assets/images/pullMsg.png" class="pullDown"> -->
    <pullDown :width="110" :height="150" :title="'户型详情'" :url="require('../../assets/images/pullMsg.png')" top="13%" right="1%"></pullDown>
    <!-- 标题 -->
    <div class="house-title">
      <img
        src="https://images.jianshankeji.com/timepark_select_housetitle.svg"
      />
    </div>
    <div class="back-icon" @click="backSelect">
      <img src="~@/assets/Back.svg" alt="" srcset="" />
    </div>
    <div class="house-show">
      <!-- 模型文件需要放在public等相对路径下,绝对路径不能加载 -->
      <model-gltf
        src="/A1.gltf"
        :width="898"
        :height="414"
        :backgroundColor="'rbg(0,0,0)'"
        :backgroundAlpha="0"
        :lights="[
            {
              type: 'DirectionalLight',
              position: { x: 1, y: 1, z: 1 },
              color: 0xffffff,
              intensity: 0.8,
            },
            {
              type: 'DirectionalLight',
              position: { x: -1, y: 1, z: 1 },
              color: 0xffffff,
              intensity: 0.8,
            },
            {
              type: 'DirectionalLight',
              position: { x: 1, y: 1, z: -1 },
              color: 0xffffff,
              intensity: 0.8,
            },
            {
              type: 'DirectionalLight',
              position: { x: -1, y: 1, z: -1 },
              color: 0xffffff,
              intensity: 0.8,
            },
            {
              type: 'DirectionalLight',
              position: { x: 0, y: -1, z: 0 },
              color: 0xffffff,
              intensity: 0.8,
            } 
        ]"
        id="test"
        ref="model"
       :rotation="rotation"
        :cameraRotation="cameraRotation"
        @on-mousemove="clickObj"
      ></model-gltf>
    </div>
    <!-- <rightDrawer>
      <div class="right-drawer">
        <img
          class="house-data"
          src="https://images.jianshankeji.com/timepark_house_data.png"
          alt=""
          srcset=""
        />
        <div class="positionContainer">
          <div
            v-for="(item, index) in houseData"
            :key="index"
            :class="[
              'charging-ball',
              index % 2 == 1 ? 'charging-ball-blue' : '',
              item.name,
            ]"
          >
            <div class="wave-wrapper" :style="{ bottom: percent1 + '%' }"></div>
          </div>
          <div
            v-for="(item, d_index) in houseData"
            :key="'d' + d_index"
            :class="['font-style', `${item.name}txt`]"
          >
            {{ item.txt }}
          </div>
        </div>
        <img
          class="house-dataimg"
          src="https://images.jianshankeji.com/timepark_house_dataimg.png"
          alt=""
          srcset=""
        />
      </div>
    </rightDrawer> -->
  </section>
</template>

<script>
import {
  ModelObj,
  ModelThree,
  modelFbx,
  ModelCollada,
  ModelStl,
  ModelPly,
  ModelGltf,
} from "vue-3d-model";
export default {
  data() {
    return {
      houseData: [
        { name: "hxmj", txt: "53.49m²" },
        { name: "tnmj", txt: "37.33m²" },
        { name: "dcts", txt: "4户" },
      ],
      percent1: 25,
      rotation: { x: 0, y: 0, z: 0 },
      intersected: null,
      cameraRotation:{ x: 9, y: 2, z: -1 },
      getWidth:null,
      getHeight:null,
    };
  },

  components: { ModelObj,ModelGltf },

  mounted() {
    // this.rotate()
    this.getHeight = document.documentElement.clientHeight
    this.getWidth = document.documentElement.clientWidth
    console.log('获取屏幕宽高',this.getWidth,this.getHeight);

  },

  methods: {
    backSelect() {
      wx.miniProgram.redirectTo({
        url: "/pages/select/select", // 小程序中页面的路径
      });
    },
    clickObj(event) {
      console.log(event); // event: { distance, face, faceIndex, point, index, uv, object }

      if (!event) {
        if (this.intersected) {
          this.intersected.material.color.setStyle("#fff");
        }

        this.intersected = null;
        return;
      }

      this.intersected = event.object;
      this.intersected.material.color.setStyle("#13ce66");
    },
    rotate() {
      this.rotation.x += 0;
      // requestAnimationFrame(this.rotate);
    },
  },
};
</script>
<style lang='scss' scoped>
.three-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  // background-image: url(https://images.jianshankeji.com/huxing1.png);
  .bg{
    width: 100%;
    height: 100%;
  }
  .pullDown{
    width: 130px;
    height: 190px;
    position: fixed;
    right: 20px;
    top: 20px;
  }
  // .glass-box {
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 100%;
  //   backdrop-filter: blur(5px);
  //   background: rgba(255, 255, 255, 0.3);
  // }
  .house-title {
    position: absolute;
    top: 0px;
    left: 59px;
    width: 127px;
    height: 63px;
    z-index: 5;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .back-icon {
    position: absolute;
    top: 10px;
    left: 15px;
    width: 30px;
    height: 30px;
    z-index: 2;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .house-show {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    border: 1px solid red;
    .swiper-box {
      height: 100%;
    }
  }
}
.right-drawer {
  margin-top: 20px;
  .house-data {
    width: 100%;
    margin-bottom: 8px;
  }
  .house-dataimg {
    width: 100%;
  }
  .positionContainer {
    // width: 40px;
    // border: 1px solid red;
    position: absolute;
    right: 15px;
    top: 0;

    .charging-ball {
      position: absolute;
      top: 16vmin;
      right: 1vmin;
      align-items: center;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      background-color: #dbc54f;
      overflow: hidden;
      border: 2px solid #d6c250;
      // outline:#d6c250 ridge  2px ;
      z-index: 100;
      display: flex;
      justify-content: center;
      align-items: center;

      .wave-wrapper {
        position: absolute;
        left: 50%;
        width: 65px;
        height: 80px;
        background-color: rgba($color: #46483f, $alpha: 0.2);
        border-radius: 50%;
        /* 动画完成花费的时间 */
        animation-duration: 5s;
        animation-name: rotate;
        /* 无限次播放动画 */
        animation-iteration-count: infinite;
        /* 动画从头到尾的速度是相同的 */
        animation-timing-function: linear;
      }

      /* 过渡动画 */
      @keyframes rotate {
        0% {
          transform: translate(-50%, 0) rotateZ(0deg);
        }

        50% {
          transform: translate(-50%, -3%) rotateZ(180deg);
        }

        100% {
          transform: translate(-50%, 0) rotateZ(360deg);
        }
      }
    }
    .font-style {
      color: #fff;
      font-size: 12px;
      font-weight: 500;
      width: 60px;
      z-index: 101;
      right: 0;
      text-align: center;
    }
    .hxmj {
      position: absolute;
      top: 5px;
    }
    .hxmjtxt {
      position: absolute;
      top: 25px;
    }
    .tnmj {
      position: absolute;
      top: 80px;
    }
    .tnmjtxt {
      position: absolute;
      top: 100px;
    }
    .dcts {
      position: absolute;
      top: 155px;
    }
    .dctstxt {
      position: absolute;
      top: 175px;
    }
  }
}
</style>